import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Alert, Badge, Button } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';
import CommonPagination from '../components/CommonPagination';

import CommonToast from '../components/CommonToast';
import CommonConfirmModal from '../components/CommonConfirmModal';
import CommonAlert from '../components/CommonAlert';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonButton from '../components/CommonButton';
import CustomDatePicker from "../components/CommonDatePicker";
import CommonLoadingBar from '../components/CommonLoadingBar';

import CommonTokenExpired from '../components/CommonTokenExpired';

import * as constants from '../../config/constants/AppConstants';
import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

import { GlobalStates } from '../states/GlobalStates';

/** individual page state */
import { PageDataState } from '../states/EB02DataTrainingDetailsState';

/** requester handle */
import requester from "../../library/Requester"; 

/** define end point */
const TABLE = `training_details_eb_02`;
const URL = `api/master/${TABLE}`;

const PARENT = 'course_eb_02_id';

class InlineEB02DataTrainingDetails extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);

        this.inlineInputRowRef = React.createRef();
    }

    initialize = async () => {
        let {fkId, fkVal, fkUserCookie} = this.props;
        
        await Actions.parametersInline(this.updateState, PARENT, {id: fkId, value: fkVal});
        
        if (fkId && fkVal) {
            await this.loadMasterbase();
            await this.loadDataTable();
            await this.setDefaultInputs();
        }
    }    

    loadMasterbase = async () => {
        let { Inputs } = this.state;
        let sets = [
            {key: "training_details_eb_02", filter: [{ field: 'id', value: Inputs?.training_details_eb_02_id?.value }]},
            {key: "training_details_enterprise_eb_02_lists", filter: [{ field: 'course_eb_02_id', value: Inputs?.course_eb_02_id?.value }]},
            {key: "enterprise", filter: [{ field: 'status', value: '0' }]},            
        ]; 
        Actions.loadMasterbase(this.updateState, sets);
    }       

    loadDataTable = async (search=false) => { 
        const { Searchs, DataTable } = this.state;
        await Actions.loadDataTable( 
            this.updateState, 
            `${URL}/pagination`, 
            fn.getInputSearch({...Searchs, page: { id: 'page', value: search ? 1 : DataTable.pagination.currentPage }})
        );
    }

    reorder = async (obj) => {
        await Actions.reorder(this.updateState,`${URL}/reorder`, obj, this.loadDataTable);
    }

    setDefaultInputs = async () => {
        await Actions.setDefaultInputs(this.updateState, PARENT, async () => {
            const { Action, Inputs } = this.state;
        
            if (['new', 'confirm-delete'].includes(Action.Mode) && Action.Inline.show === true) {
                let sequenceField = 'seq';
                let filterField = 'course_eb_02_id';
                let result = await Actions.getMaxSequence(this.updateState, URL + '/get-max-sequence', {sequenceField: sequenceField, filter: [{field: filterField, value: Inputs[filterField].value}]});
                if(result.success){ Inputs[sequenceField].value = result.seq; }
                this.setState({Inputs: Inputs});
            }
        });
    }    

    fetchForEdit = async (obj) => {
        await Actions.fetchForEdit(
            this.updateState,
            `${URL}/${obj.id}`, 
            {element: 'Inline', mode: 'update', bool: true},
        );

        setTimeout(() => {
            if (this.inlineInputRowRef && this.inlineInputRowRef.current) {
                this.inlineInputRowRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        }, 100);         
    }

    resetInlineInputs = () => {
        Actions.handleResetActionInline(this.updateState);
        Actions.handleDiscardInputs(this.updateState, 'Inputs');
        this.setDefaultInputs();
    }
                                                          
    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state; 
        await Actions.submitData(
            this.updateState,
            `${URL}`,
            Action.Mode, 
            fn.getInputForm({...Inputs}),
            this.loadDataTable
        );

        let result = this.state.Action.Alert.mode;
        
        if(['new-success', 'update-success'].includes(result)){ 
            this.resetInlineInputs();
        }
    }

    deleteData = async () => {
        const { Deletes } = this.state;
        await Actions.deleteData(this.updateState, `${URL}`, Deletes, this.loadDataTable);
        await this.setDefaultInputs();
    }  
   
    componentDidMount = async () => { 
        await this.initialize();
    }

    componentDidUpdate = async (prevProps) => {
        if (prevProps.fkVal !== this.props.fkVal && !util.isEmpty(this.props.fkVal)) {
            await this.initialize();
        }        
    }

    render = () => {

        let { Action, DataTable, Inputs, Masterbase, Deletes, Operation, Parameters, Token } = this.state;
        
        let fkUserCookie = this.props.fkUserCookie

        let { onDrillDownInline , onGenEnrollKey} = this.props

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;

        let { show, mode } = Action.Inline;

        let { Submit } = Operation;

        let isLoading = Action.Loading.submit;

        let totalPersonCount = 0, totalDurationDays = 0, totalTrainingHours = 0; 

        const isFk = Parameters[PARENT]?.parameters?.element?.find(item => item.id === PARENT)?.value ?? null;           

        return (
            <Container fluid className="data-table-container">

                <CommonTokenExpired Token={Token} />
                
                <CommonToast 
                    toast={Action.Toast} 

                    onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                />

                <CommonConfirmModal 
                    Action={Action}
                    Deletes={Deletes}

                    onCallback={async (e) => { 
                        let result = await Actions.handleControlModal(this.updateState, e);
                        if(result.action){
                            if (result.section === 'Delete'){ await this.deleteData(); }
                        }
                    }}
                />

                {util.isEmpty(isFk) ? 
                    <Alert key="light" variant="danger" className="custom-alert-border">
                        <i className="fa-classic fa-light fa-circle-exclamation fa-fw me-2"></i>
                         กรุณาบันทึก แบบขออนุมัติจัดอบรมระยะสั้นตามแนวทางอีอีซีโมเดล ก่อนดำเนินการ บันทึก รายละเอียดการฝึกอบรมที่ขออนุมัติ
                    </Alert>                
                :                
                    <>
                        <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
            
                        <Row>
                            <Col md={12}>
                                <>
                                    <Table 
                                        responsive 
                                        borderless 
                                        className={`table-advance ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                                        style={{marginTop: '0px'}}
                                    >
                                        <thead>
                                            <tr>
                                                <th className="th-td-align-center th-width-50p align-top"></th>
                                                <th className="th-td-align-center th-width-100p th-font-sm align-top">รุ่นที่</th>
                                                <th className="th-td-align-center th-width-300p th-font-sm align-top">สถานประกอบการ</th>
                                                <th className="th-td-align-center th-width-200p th-font-sm align-top">Enroll Key</th>
                                                <th className="th-td-align-center th-width-125p th-font-sm align-top">จำนวน (คน)</th>                                                  
                                                <th className="th-td-align-center th-width-150p th-font-sm align-top">ระยะเวลา (วัน)</th>
                                                <th className="th-td-align-center th-width-125p th-font-sm align-top">อบรม (ชั่วโมง)</th> 
                                                <th className="th-td-align-center th-width-300p th-font-sm align-top">วันที่อบรม</th>    
                                                <th className="th-width-75p"></th>
                                                <th className="th-td-align-center th-width-75p">
                                                    {DataTable?.rows?.length > 0 && !!Deletes?.deletes?.length && (
                                                        <CommonButton 
                                                            task="delete-no-text" 
                                                            rounded={true}
                                                            disabled={false}
                                                            callback={(e) => 
                                                                Actions.handleControlModal(this.updateState, {mode: 'confirm-delete', show: true, action: false})
                                                            } 
                                                        />
                                                    )}                                          
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {DataTable.rows.map((row, index) => {
                                                
                                                Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });

                                                rowId++;

                                                let del = true;

                                                let trainingPeriod = (() => {
                                                    let { training_start_date, training_end_date } = row;

                                                    if (util.isEmpty(training_end_date)) { 
                                                        training_end_date = training_start_date; 
                                                    }

                                                    training_start_date = util.convertDateToBE(training_start_date);
                                                    training_end_date = util.convertDateToBE(training_end_date);

                                                    const start = util.parseDate(training_start_date);
                                                    const end = util.parseDate(training_end_date);

                                                    return util.displayDateRange(start, end);
                                                })();             
                                                
                                                totalPersonCount += Number(row.person_count);
                                                totalDurationDays += Number(row.duration_days);
                                                totalTrainingHours += Number(row.training_hours);
                                                
                                                const enterpriseNames = (Masterbase?.training_details_enterprise_eb_02_lists || [])
                                                    .filter(item => item?.training_details_eb_02_id === row?.id)
                                                    .sort((a, b) => a?.seq - b?.seq)
                                                    .map(item => item?.enterprise_name);                                             

                                                return (    
                                                    <React.Fragment key={`${rowId}-${row.id}`}>
                                                        <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                            <td className="th-td-align-center align-top"></td>                                                            
                                                            <td className="th-td-align-center td-font-sm align-top" title={row.model_no}>
                                                                {row.model_no}
                                                            </td>
                                                            <td className="td-font-sm align-top">
                                                             
                                                                {enterpriseNames.map((name, index) => (
                                                                <div key={index}>
                                                                    <p className="text-muted mb-1">{name}</p>
                                                                    <hr className="my-1" style={{color: '#222'}} />
                                                                </div>
                                                                ))}
                                                       

                                                                <div className={`text-center ${enterpriseNames.length > 0 ? 'mt-2' : ''}`}>
                                                                    <Button 
                                                                        variant="primary"
                                                                        className="d-flex align-items-center btn-rounded" 
                                                                        size="xs"
                                                                        onClick={(e) => onDrillDownInline(
                                                                            {   key: 'training_details_enterprise',  
                                                                                fk: 'training_details_eb_02_id',
                                                                                val: row.id,
                                                                                page: this.state.DataTable.pagination.currentPage,
                                                                            })}
                                                                    >
                                                                        <i className="fa-classic fa-light fa-circle-chevron-down fa-fw me-2"></i> 
                                                                        สถานประกอบการ  
                                                                        <Badge bg="dark" pill className="ms-2">{util.formatNumber(row.enterprise_rows, true)}</Badge>                                                     
                                                                    </Button>
                                                                </div>
                                                                
                                                            </td>
                                                            <td className="th-td-align-center td-font-sm align-top">
                                                                {/* {(console.log("InlineEB02DataTrainingDetails UserCookie : ",UserCookie))} */}
                                                                {row.enroll_key ? (util.formatLabel(row.enroll_key)) : 
                                                                    fkUserCookie.types !== '2' || fkUserCookie.subtypes === '0' ?
                                                                    <Button
                                                                        variant="primary"
                                                                        className="d-flex align-items-center btn-rounded"
                                                                        size="xs"
                                                                        onClick={async () => {
                                                                            await onGenEnrollKey({
                                                                                key: 'training_details_enterprise',
                                                                                fk: 'training_details_eb_02_id',
                                                                                val: row.id,
                                                                            });

                                                                            await this.loadDataTable();
                                                                        }}
                                                                    >
                                                                        <i className="fa-classic fa-light fa-circle-chevron-down fa-fw me-2"></i>
                                                                        สร้าง Enroll Key
                                                                    </Button>
                                                                    :''
                                                                }
                                                            </td>
                                                            <td className="th-td-align-center td-font-sm align-top" title={util.formatNumber(row.person_count)}>
                                                                {util.formatNumber(row.person_count)}
                                                            </td>                                                             
                                                            <td className="th-td-align-center td-font-sm align-top" title={util.formatNumber(row.duration_days)}>
                                                                {util.formatNumber(row.duration_days)}
                                                            </td>  
                                                            <td className="th-td-align-center td-font-sm align-top" title={util.formatNumber(row.training_hours)}>
                                                                {util.formatNumber(row.training_hours)}
                                                            </td> 
                                                            <td className="th-td-align-center td-font-sm align-top" title={trainingPeriod}>
                                                                {trainingPeriod}  
                                                            </td>                                                                                                                           
                                                            <td className="th-td-align-center align-top">
                                                                <CommonButton 
                                                                    task="edit" 
                                                                    rounded={false}
                                                                    disabled={false}
                                                                    inlineClass="btn-font-sm"
                                                                    callback={(e) => this.fetchForEdit({id: row.id})} 
                                                                />
                                                            </td>
                                                            <td className="th-td-align-center align-top">
                                                                {del && (
                                                                    <Form.Check 
                                                                        type="checkbox"
                                                                        name="deletes"
                                                                        value={row.id}
                                                                        checked={Deletes.deletes.includes(row.id)}
                                                                        onChange={(e) => Actions.handleDataTableToggleDelete(this.updateState, e)} 
                                                                        className="checkbox-font-sm" 
                                                                    />
                                                                )}                                                        
                                                            </td>                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                        </tr>                                                        
                                                    </React.Fragment>                                
                                                )
                                            })}   

                                            {DataTable?.rows?.length > 0 && (
                                                <tr>
                                                    <td colSpan={3} className="td-font-sm text-end"><b>รวม</b></td>
                                                    <td colSpan={3} className="td-font-sm text-end"></td>
                                                    <td className="td-font-sm th-td-align-center" title={util.formatNumber(totalPersonCount)}>
                                                        <b>{util.formatNumber(totalPersonCount)}</b>
                                                    </td>  
                                                    <td className="td-font-sm th-td-align-center" title={util.formatNumber(totalDurationDays)}>
                                                        <b>{util.formatNumber(totalDurationDays)}</b>
                                                    </td>  
                                                    <td className="td-font-sm th-td-align-center" title={util.formatNumber(totalTrainingHours)}>
                                                        <b>{util.formatNumber(totalTrainingHours)}</b>
                                                    </td>     
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>                                                                                                                                                             
                                                </tr>
                                            )}

                                            <React.Fragment key={`inline-input-form`}>
                                                <tr ref={this.inlineInputRowRef}>
                                                    <td className="th-td-align-center align-top"><i className="fa-classic fa-light fa-circle-arrow-right fa-fw"></i></td> 
                                                    <td className="align-top">
                                                        <CommonInput
                                                            element="Inputs"
                                                            input={Inputs.model_no}
                                                            size="sm"
                                                            hr={false}
                                                            callback={(e, element) =>  Actions.handleInputChange(this.updateState, element, e)} 
                                                            disabled={false}
                                                            floatingLabel={false}
                                                        />                                               
                                                    </td>
                                                    <td className="text-center">
                                                        <Badge bg="dark" pill>สามารถทำการเพิ่ม ภายหลังบันทึก รุ่นที่จัดอบรม</Badge>
                                                    </td> 
                                                    <td className="text-center"> </td> 
                                                    <td className="align-top">
                                                        <CommonInput
                                                            element="Inputs"
                                                            input={Inputs.person_count}
                                                            size="sm"
                                                            hr={false}
                                                            callback={(e, element) =>  Actions.handleInputChange(this.updateState, element, e)} 
                                                            disabled={false}
                                                            floatingLabel={false}
                                                        />                                               
                                                    </td>                                                    
                                                    <td className="align-top">
                                                        <CommonInput
                                                            element="Inputs"
                                                            input={Inputs.duration_days}
                                                            size="sm"
                                                            hr={false}
                                                            callback={(e, element) =>  Actions.handleInputChange(this.updateState, element, e)} 
                                                            disabled={false}
                                                            floatingLabel={false}
                                                        />                                               
                                                    </td>    
                                                    <td className="align-top">
                                                        <CommonInput
                                                            element="Inputs"
                                                            input={Inputs.training_hours}
                                                            size="sm"
                                                            hr={false}
                                                            callback={(e, element) =>  Actions.handleInputChange(this.updateState, element, e)} 
                                                            disabled={false}
                                                            floatingLabel={false}
                                                        />                                               
                                                    </td> 
                                                    <td className="align-top">
                                                        <div className="d-flex align-items-start gap-1">
                                                            <CustomDatePicker
                                                                element="Inputs"
                                                                input={Inputs.training_start_date}
                                                                size="sm"
                                                                hr={false}
                                                                floatingLabel={false}
                                                                callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                                            />
                                                            <div className="px-1">-</div>
                                                            <CustomDatePicker
                                                                element="Inputs"
                                                                input={Inputs.training_end_date}
                                                                size="sm"
                                                                hr={false}
                                                                floatingLabel={false}
                                                                callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                                            />
                                                        </div>                                                                                                              
                                                    </td>   
                                                    <td colSpan = "2" className="align-top">
                                                        <div className="d-flex justify-content-center">
                                                            <CommonButton 
                                                                task={`${mode}-no-text`} 
                                                                disabled={isLoading ? true : Submit ? false : true}
                                                                callback={async (e) => await this.submitData() }
                                                            /> 

                                                            <CommonButton 
                                                                task="discard-no-text" 
                                                                inlineClass="ms-2" 
                                                                disabled={isLoading} 
                                                                callback={(e) => this.resetInlineInputs()}
                                                            />  
                                                        </div>                                                                                   
                                                    </td>                                                                                                                                                                                                                                                             
                                                </tr>
                                            </React.Fragment>  
                                                                                                                                                                             
                                        </tbody>
                                    </Table>    
                                    
                                    <CommonAlert 
                                        alert={Action.Alert} 
                                        size="sm"
                                        callback={(e) => Actions.handleCloseAlert(this.updateState, 'Alert', e)}
                                    />    

                                    <CommonLoadingBar isLoading={isLoading} />   

                                    {!DataTable?.rows?.length > 0 && (
                                        <>{/** <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} /> */}</>  
                                    )}                                                    
                                </>   

                                {!Action.Loading.dataTable && (DataTable.pagination.totalPages > 1) && (
                                    <CommonPagination 
                                        Pagination={DataTable.pagination} 

                                        handlePagination={(paging) => {
                                            Actions.handleDataTablePaginationChange(this.updateState, paging, this.loadDataTable)                                    
                                        }}
                                    />
                                )}
                            </Col>
                        </Row>
                    </>
                }
            </Container>                        
        )
    }
}

export default InlineEB02DataTrainingDetails;